import React from 'react'
import MainBlock from './MainBlock/MainBlock'
import EuropeanWindows from './European/EuropeanWindows'
import Materials from './Materials/Materials'
import Product from './Product/Product'
import Characters from './Characters/Characters'
import Catalog from './Catalog/Catalog'
import Form from '../../Modules/Form/Form'
import Lamination from './Lamination/Lamination'

const WindowsPage = () => {
  return (
    <div>
      <MainBlock />
      <EuropeanWindows/>
      <Materials/>
      <Product/>
      <Lamination/>
      {/*<Certificates/>*/}
      <Characters/>
      <Catalog/>
      <Form/>
    </div>
  )
}

export default WindowsPage
